import React, { Component } from 'react';
import './AppShell.css';
import { logout } from '../services/auth/authService';
import { SidebarNav } from './SidebarNav';

export class AppShell extends Component {
  static displayName = AppShell.name;

  handleLogout = () => {
    logout();
  };

  render() {
    const { children, variant } = this.props;

    return (
      <div className="app-shell">
        <aside className="app-shell__sidebar">
          <div className="app-shell__brand">
            <img
              src={`${process.env.PUBLIC_URL}/img/logo-liceo.png`}
              alt="Liceo Cultural Docente N°8055"
              className="app-shell__brand-logo"
            />
            <p className="app-shell__brand-name">Liceo Cultural Docente N°8055</p>
            <button
              type="button"
              className="app-shell__logout"
              onClick={this.handleLogout}
            >
              Cerrar sesión
            </button>
          </div>
          <SidebarNav variant={variant} />
        </aside>

        <main className="app-shell__content">
          {children}
        </main>
      </div>
    );
  }
}
